import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';

const initialState = {
	loading: false,
	error: null,
	list: [],
};

export default function visits(state = initialState, action) {
	switch (action.type) {
		// after START action set LOADING clear ERR
		case actionTypes.VISITS_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		// if response FAILED set ERR and clear LOADING
		case actionTypes.VISITS_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload.errors,
			};
		// 	SUCCEED response below:
		// 	on SUCCEED clear ERR and LOADING, set RESPONSE:
		case actionTypes.VISITS_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				list: action.payload,
			};
		case actionTypes.AUTH_LOGOUT:
			return initialState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/reducers/visits.js